// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"c96835ee","222":"059b84b4","532":"ca0a9330","669":"12139e00","683":"cc7ee16e","787":"63547323","799":"3eb5cfe6","854":"d5037312","872":"d532a24f","922":"a38a5059","961":"58f556da","982":"4740e591"}[chunkId] + ".css";
};